import "./HeavyUpEnrollPage.scss";
import React from "react";
import { useSearchParams } from "react-router-dom";
import HeavyUpFormHeader from "./HeavyUpFormHeader";
import ProgressBar from "../../components/form/ProgressBar";
import HeavyUpFormEmbed from "../../components/form/HeavyUpFormEmbed";
import { findPlanById } from "./heavyUpContent";

const HeavyUpEnrollPage = () => {
	const [searchParams] = useSearchParams();
	const selectedPlan = findPlanById(searchParams.get("plan"));

	React.useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="hu-enroll-page">
			<HeavyUpFormHeader />
			<ProgressBar currentPage={2} hideBar />
			<HeavyUpFormEmbed selectedPlan={selectedPlan} />
		</div>
	);
};

export default HeavyUpEnrollPage;
